import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ActionComponent from '../../../../components/ActionComponent'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import { getDate } from '../../../../utils/DateUtil'
import { getMapStateToProps, getPropTypes } from '../../../../utils/StoreUtils'
import { getSandreLabel } from '../../../../utils/StringUtil'
import { Card, CardContent, Grid2 } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'


const storeProps = {
    sandreCodes: false,
}

class InstallationArrangementDashboard extends ActionComponent {
    getSummary = (arrangements) => {
        if (arrangements && arrangements.length) {
            const space = <span className='padding-left-3'/>
            const data = arrangements.map(a => (<h6>{ getDate(a.startDate) } { space }
                { getSandreLabel(this.props.sandreCodes, SANDRE.ARRANGEMENT_TYPES, a.arrangementType) } { space } { a.descriptive }</h6>))
            return (
                <Grid2 size={12}>
                    <Card>
                        <CardTitle title={i18n.arrangements}/>
                        <CardContent>
                            {data}
                        </CardContent>
                    </Card>
                </Grid2>
            )
        }
        return null
    }

    render() {
        return this.getSummary(this.props.station.link_arrangements)
    }
}

InstallationArrangementDashboard.propTypes = getPropTypes(storeProps, {
    station: PropTypes.object,
})

const mapStateToProps = () => getMapStateToProps(storeProps)

export default connect(mapStateToProps)(InstallationArrangementDashboard)
